module.exports = __webpack_public_path__ + "img/twitter-black.81664517.svg";